import CollectionDataGrid from '@/components/CollectionDataGrid'
import { pbUpsert, useCollection } from '@/pb'
import { arrayToObject, objectMap, useInputState } from '@/utils'
import { Button, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { useMemo } from 'react'

const Editor = ({ row, onClose }) => {
  const [name, setName] = useInputState(row?.name)
  return <>
    <DialogTitle>Производитель</DialogTitle>
    <DialogContent className="editorForm">
      <TextField label={fields.code.headerName} value={row?.code} disabled />
      <TextField label={fields.name.headerName} value={name} onChange={setName} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} >Отмена</Button>
      <Button onClick={() => pbUpsert('manufacturers', { id: row?.id, name }).then(onClose)} variant="contained">Сохранить</Button>
    </DialogActions>
  </>
}

const columns = [
  { field: 'code', headerName: 'Код', width: 70, valueFormatter: value => value.toString(16).padStart(3, '0') },
  { field: 'name', headerName: 'Название', width: 300 },
]
const fields = arrayToObject(columns, 'field')

export default function Manufacturers({ title }) {

  const [manufacturers, loaded] = useCollection('manufacturers')
  
  const manufacturersCodes = useMemo(() => {
    return objectMap(manufacturers, manufacturer => ({
      ...manufacturer,
      code: manufacturer?.code?.toString(16).padStart(3, '0'),
    }))
  }, [manufacturers])

  return (
    <CollectionDataGrid
      collectionName={title}
      collection={manufacturersCodes}
      columns={columns}
      loading={!loaded}
      editor={Editor}
    />
  )

}